import React from 'react'
import { Switch, Route, BrowserRouter as Router } from 'react-router-dom'

import ProtectedRoutes from './ProtectedRoutes'
import { MAP_VIEW, LOG_IN } from './path'

import MapView from '../screens/MapView'
import Login from '../screens/LogIn'

export default function Routes() {
  return (
    <Router>
      <Switch>
        <Route exact path={LOG_IN} component={() => <Login></Login>} />

        <ProtectedRoutes
          exact
          path={MAP_VIEW}
          component={() => <MapView></MapView>}
        />
      </Switch>
    </Router>
  )
}
